module.exports = __webpack_public_path__ + "media/images/bnr_referral_pc-1c3d44ff6993a43609ff19b36b782420.jpg";